import React, { Component } from 'react';
import { Button, } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import _, { cloneDeep } from 'lodash';
import { RowRenderer } from '../../Common/rowRenderer';
import { DateFormatter2 } from '../../Common/dateFormat';
import { isAP } from '../../../actions/root_url'
import NewWeightView from './NewWeightView'

const { Selectors } = Data;

export class NewBatchesModal extends Component {
    constructor() {
        super();
        this.state = {
            quantityRemaining: 0,
            batches: {
                rows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
                editedRows: [],
            },
            IsOverSaleable: false,
            weights: [],
            isNonFixed: true,
            showBatches: true,
            batch_id: -1,
            updateBatchId: -1,
            totalLoaded: 0,
        }
    }

    componentDidMount() {
        if (isAP) {
            this.props.fetchBatches();
            this.setState({
                isNonFixed: this.props.selectedRow.ProductType == 'Non-Fixed',
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((isAP) && nextProps.batchesInfo !== this.props.batchesInfo && nextProps.batchesInfo.batches.length) {
            this.initBatches(nextProps.batchesInfo.batches)
        }
    }

    componentWillUnmount() {
        this.setState({
            quantityRemaining: 0,
            batches: {
                rows: [],
                filters: {},
                sortColumn: null,
                sortDirection: null,
                editedRows: [],
            },
            IsOverSaleable: false,
            weights: [],
            isNonFixed: true,
            showBatches: true,
            batch_id: -1,
            updateBatchId: -1,
            totalLoaded: 0,
        })
    }

    initBatches = (batchesInfo = []) => {
        const { selectedRow, } = this.props;
        const rowBatches = ((selectedRow || { deducted_batch: [] }).deducted_batch || []).map((bat, index) => ({ ...bat, index })) || [];
        let quantityRemaining = Number(this.props.quantityValue);
        let index = 0;
        let sumQty = rowBatches.reduce((a, b) => a + Number(b.quantity), 0);
        let showBatches = true;
        if (rowBatches.length && rowBatches[0].isAuto || selectedRow.isAuto) {
            showBatches = false;
        }
        quantityRemaining -= sumQty;
        let batchesRows = batchesInfo.map(r => {
            let rowIndex = rowBatches.findIndex(bat => bat.batch_id == r.id);
            if (rowIndex != -1) {
                return {
                    Idx: index++,
                    batch_id: r.id,
                    Brand: r.Brand,
                    quantity: rowBatches[rowIndex].quantity,
                    oldQty: rowBatches[rowIndex].quantity,
                    expire_datetime: r.expire_datetime,
                    location: r.location,
                    batch_num: r.batch_num,
                    availableQty: r.quantity,
                    is_initial_batch: r.is_initial_batch,
                    totalWt: r.weight,
                    weight: rowBatches[rowIndex].weight,
                };
            }
            return {
                Idx: index++,
                batch_id: r.id,
                Brand: r.Brand,
                quantity: 0,
                oldQty: 0,
                expire_datetime: r.expire_datetime,
                location: r.location,
                batch_num: r.batch_num,
                availableQty: r.quantity,
                is_initial_batch: r.is_initial_batch,
                totalWt: r.weight,
                weight: 0,
            };
        });
        let weights = [];
        if (selectedRow.Weights && Array.isArray(selectedRow.Weights)) {
            weights = selectedRow.Weights.map(wt => ({ weight: wt }));
        }
        let totalWt = weights.reduce((a, b) => a + Number(b.weight), 0);
        const batches = {
            ...this.state.batches,
            rows: batchesRows,
        }
        this.setState({
            batches,
            quantityRemaining,
            NetWeight: selectedRow.NetWeight,
            weights,
            batchTotalWt: totalWt,
            showBatches,
            totalLoaded: Number(this.props.quantityValue),
            IsOverSaleable: selectedRow.IsOverSaleable,
        });
    }

    handleOnSubmit = (e) => {
        const { showBatches, batches, isNonFixed, weights, NetWeight } = this.state;
        let totalWeight = 0;
        const batchRows = [];
        let sumQty = 0;
        batches.rows.map((row) => {
            sumQty += Number(row.quantity || 0);
            totalWeight += Number(row.weight);
        });
        let sumWt = weights.reduce((a, b) => a + Number(b.weight), 0);
        if (showBatches) {
            if (isNonFixed && (sumWt != totalWeight || sumQty != weights.length)) {
                alert('The selected batch quantity and weight must be consistent with the quantity and weight filled in on the right side')
                return
            }
        }
        if (isNonFixed && sumWt <= 0) {
            alert('Weight cannot be empty.');
            return
        }

        batches.rows.map((row) => {
            if (row.quantity > 0) {
                let cpRow = {
                    batch_id: row.batch_id,
                    Brand: row.Brand,
                    expire_datetime: row.expire_datetime,
                    location: row.location,
                    quantity: row.quantity,
                    weight: row.weight,
                    batch_num: row.batch_num,
                    isAuto: !showBatches,
                }
                batchRows.push(cpRow);
            }
        });
        let wts = weights.map(wt => wt.weight);
        if (!isNonFixed && !showBatches) {
            let qty = Number(this.props.quantityValue);
            sumWt = parseFloat(qty * NetWeight);
            sumQty = qty;
        }
        this.props.returnBatch(sumWt.toFixed(2), batchRows, sumQty, !showBatches, wts);
        this.props.close();
    };

    handleSetWeight = (total, weights) => {
        const { batches, IsOverSaleable, updateBatchId } = this.state;
        let cpRows = [];
        let subWt = batches.rows.reduce((a, b) => a + Number(b.weight), 0);
        let subAvWt = batches.rows.reduce((a, b) => a + Number(b.totalWt), 0);
        let subQty = batches.rows.reduce((a, b) => a + Number(b.quantity), 0);
        let lineWt = Number(total - subWt);
        let lineQty = weights.length - subQty;
        if (total > subAvWt && !IsOverSaleable) {
            alert(`The weight of non oversold products cannot exceed the batch weight`);
            return
        }
        let rows = batches.rows;
        let initBatchIndex = -1;
        if (weights.length == 0) {
            cpRows = rows.map(row => ({ ...row, weight: 0, quantity: 0, oldQty: 0 }))
        } else if (updateBatchId != -1) {
            for (let i = 0; i < rows.length; i++) {
                if (rows[i].batch_id == updateBatchId) {
                    if (rows[i].totalWt < Math.abs(lineWt) + Number(rows[i].weight) && !(rows[i].is_initial_batch && IsOverSaleable)) {
                        alert(`The weight of non oversold products cannot exceed the batch weight(${rows[i].batch_num})`);
                        return
                    }
                    let currentQty = Number(rows[i].availableQty);
                    let currentLoadedQty = Number(rows[i].quantity);
                    let loadedQty = 0;
                    if (currentQty >= currentLoadedQty + lineQty) {
                        loadedQty = currentLoadedQty + lineQty;
                    } else {
                        loadedQty = currentQty;
                    }
                    cpRows.push({ ...rows[i], weight: lineWt + Number(rows[i].weight), quantity: loadedQty, oldQty: loadedQty });
                    lineWt = 0;
                } else {
                    cpRows.push({ ...rows[i] });
                }
            }
        } else {
            for (let i = 0; i < rows.length; i++) {
                if (lineWt == 0) {
                    cpRows.push({ ...rows[i] });
                    continue
                }
                let currentQty = Number(rows[i].availableQty);
                let currentLoadedQty = Number(rows[i].quantity);
                if (lineWt < 0) {
                    if (Math.abs(lineWt) > rows[i].weight) {
                        cpRows.push({ ...rows[i], weight: 0, oldQty: 0, quantity: 0 });
                        lineWt += Number(rows[i].weight);
                    } else {
                        cpRows.push({ ...rows[i], weight: Number(rows[i].weight) + lineWt });
                        lineWt = 0;
                    }
                } else {
                    if (rows[i].is_initial_batch) {
                        initBatchIndex = i;
                        cpRows.push({ ...rows[i] })
                        continue
                    }
                    if (rows[i].weight + lineWt > rows[i].totalWt) {
                        cpRows.push({ ...rows[i], weight: rows[i].totalWt, quantity: currentQty, oldQty: currentQty });
                        lineQty -= currentQty - currentLoadedQty;
                        lineWt -= rows[i].totalWt - rows[i].weight;
                    } else {
                        let loadedQty = 0;
                        if (currentQty >= currentLoadedQty + lineQty) {
                            loadedQty = currentLoadedQty + lineQty;
                        } else {
                            loadedQty = currentQty;
                        }
                        cpRows.push({ ...rows[i], weight: rows[i].weight + lineWt, quantity: loadedQty, oldQty: loadedQty });
                        lineWt = 0;
                        lineQty = 0;
                    }
                }
            }
        }
        if (lineWt > 0 && IsOverSaleable && initBatchIndex != -1) {
            let wt = cpRows[initBatchIndex].weight
            cpRows[initBatchIndex].weight = wt + lineWt;
        }
        this.setState({
            batches: { ...batches, rows: cpRows },
            weights,
            updateBatchId: -1,
            batchTotalWt: total,
        });
    }

    setRemainWts = (weights) => {
        this.setState({
            weights,
        });
    }

    renderBatchesTable() {
        const getRows = () => {
            if (this.state.showBatches) {
                return Selectors.getRows(this.state.batches);
            } else {
                return Selectors.getRows({ ...this.state.batches, rows: [] });
            }
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const handleRowUpdated = e => {
            const rows = getRows();
            if (e.updated.quantity != null) {
                let oldQty = rows[e.rowIdx].quantity;
                Object.assign(rows[e.rowIdx], e.updated);
                let upQty = Number(e.updated.quantity);
                if (!e.updated.quantity || e.updated.quantity == 0) {
                    this.setState({ batches: { ...this.state.batches, rows } });
                    return
                }
                if (!this.state.isNonFixed) {// 不是 non-fixed
                    let totalWt = this.state.NetWeight * upQty;
                    Object.assign(rows[e.rowIdx], { weight: totalWt, oldQty });
                    this.setState({ batches: { ...this.state.batches, rows } });
                    return
                }
                Object.assign(rows[e.rowIdx], { oldQty });
                let totalLoad = rows.reduce((a, b) => a + Number(b.quantity || 0), 0);
                // non-fixed
                this.setState({
                    batches: { ...this.state.batches, rows },
                    totalLoaded: totalLoad,
                    updateBatchId: rows[e.rowIdx].batch_id,
                });
            }
            if (e.updated.weight != null) {
                if (Number(e.updated.weight) > rows[e.rowIdx].totalWt && !(rows[e.rowIdx].is_initial_batch && this.state.IsOverSaleable)) {
                    alert('The weight cannot exceed the total weight of the batch!')
                    return
                }
                Object.assign(rows[e.rowIdx], e.updated);
                let totalWt = rows.reduce((a, b) => a + Number(b.weight || 0), 0);
                this.setState({
                    batchTotalWt: totalWt,
                    batches: { ...this.state.batches, rows },
                })
            }
        }

        const handleFilterChange = (filter) => {
            const newFilters = Object.assign({}, this.state.batches.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            const batches = { ...this.state.batches, filters: newFilters }
            this.setState({ batches });
        };

        const onClearFilters = () => {
            const batches = { ...this.state.batches, filters: {} }
            this.setState({ batches });
        };

        const handleGridSort = (sortColumn, sortDirection) => {
            const batches = { ...this.state.batches, sortColumn, sortDirection };
            this.setState({ batches });
        };

        const columns = [
            {
                key: 'availableQty',
                name: <Translate value="available_qty" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 90,
            },
            {
                key: 'totalWt',
                name: <Translate value="available_wt" />,
                width: 80,
                resizable: true,
                getRowMetaData: row => row,
                formatter: ({ dependentValues }) => {
                    return <div>
                        {dependentValues.totalWt}
                    </div>
                }
            },
            {
                key: 'quantity',
                name: <Translate value="shipped_qty" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: true,
                width: 90,
                getRowMetaData: row => row,
                formatter: ({ dependentValues }) => {
                    return <div>
                        {dependentValues.quantity}
                    </div>
                }
            },
            {
                key: 'weight',
                name: <Translate value="shipped_wt" />,
                width: 80,
                editable: this.state.isNonFixed,
                resizable: true,
            },
            {
                key: 'Brand',
                name: <Translate value="brand" />,
                width: 70,
                resizable: true,
            },
            {
                key: 'expire_datetime',
                name: <Translate value="expired" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
                formatter: DateFormatter2,
            },
            {
                key: 'location',
                name: <Translate value="location" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 110,
            },
            {
                key: 'batch_num',
                name: <Translate value="batch_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
            },
        ]
        let qty = this.state.batches.rows.reduce((a, b) => a + Number(b.quantity || 0), 0);
        return (
            <div style={{ width: '100%', position: 'relative' }}>
                <div style={{ position: 'absolute', left: '10px' }}>
                    {
                        this.state.isNonFixed && this.state.showBatches
                        &&
                        <label style={{ color: 'orange', fontSize: '15px' }}><Translate value="remaining" /> Qty: {this.state.weights.length}-{qty}={this.state.weights.length - qty}(RealQty - Qty)</label>
                    }
                    <Button bsStyle="primary"
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                            this.setState({
                                showBatches: !this.state.showBatches,
                            });
                        }}>
                        <Translate value={this.state.showBatches ? "close_batches" : 'choose_batches'} />
                    </Button>
                </div>
                <div style={{ marginLeft: '10px', width: '100%' }}>
                    <ReactDataGrid
                        enableCellSelect={true}
                        rowRenderer={
                            <RowRenderer />
                        }
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize()}
                        minHeight={375}
                        minWidth={760}
                        rowHeight={25}
                        headerRowHeight={45}
                        onRowUpdated={handleRowUpdated}
                        toolbar={<Toolbar enableFilter />}
                        onAddFilter={handleFilterChange}
                        onClearFilters={onClearFilters}
                        onGridSort={handleGridSort}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div style={styles.row_container}>
                    <div>
                        {this.renderBatchesTable()}
                    </div>
                    {this.state.isNonFixed && <div style={{ height: '400px' }}>
                        <NewWeightView
                            totalLoaded={this.state.totalLoaded}
                            returnTotalWeight={this.handleSetWeight.bind(this)}
                            batchTotalWt={this.state.batchTotalWt}
                            currentWeights={this.state.weights}
                            setRemainWts={this.setRemainWts}
                        />
                    </div>}
                </div>
                <div style={styles.bot_v}>
                    <Button
                        bsStyle="danger"
                        onClick={() => {
                            this.props.close();
                            this.props.resetQty();
                        }}
                        style={{ float: 'right' }}
                    >
                        <Translate value='cancel' />
                    </Button>
                    <Button
                        bsStyle="primary"
                        onClick={this.handleOnSubmit}
                        style={{ float: 'right', marginLeft: 50 }}
                    >
                        <Translate value='confirm' />
                    </Button>
                </div>
            </div>
        );
    }
}

export default NewBatchesModal;

const styles = {
    row_container: {
        display: 'flex',
        with: '100%',
    },
    title_v: {
        display: 'flex',
        fontWeight: 'bold',
        fontSize: '20px',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bot_v: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: '30px',
        alignItems: 'center'
    },
    weight_modal: {
        width: '500px',
        height: '600px',
        top: '45%',
        marginLeft: '-10%',
    },
}



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/NewBatchesModal.jsx